/**
 * A failure that never reached the server: the browser could not complete the
 * request at all (offline, dropped Wi-Fi, DNS, a connection cut mid-flight).
 * Axios reports it as `ERR_NETWORK` / "Network Error"; fetch throws a TypeError
 * worded per engine — "Failed to fetch" (Chrome), "Load failed" (Safari),
 * "NetworkError when attempting to fetch resource." (Firefox).
 *
 * None of these are a server fault, so none of them may be rendered as one. A
 * 19-second client-side blackout used to surface as a red "Server Error" over a
 * build that finished fine 12 seconds later (2026-09-20, chat 21276421).
 *
 * Deliberately anchored: a server that *reports* "network error" inside a longer
 * message is a different thing from the browser failing to connect, and only the
 * latter may skip the blame.
 */
export function isTransportFailure(error: unknown, message: string): boolean {
  const code = (error as { code?: unknown } | null | undefined)?.code;

  if (code === 'ERR_NETWORK' || code === 'ECONNABORTED' || code === 'ETIMEDOUT') {
    return true;
  }

  return /^(network error|failed to fetch|load failed|networkerror when attempting to fetch resource\.?)$/i.test(
    message.trim(),
  );
}
